import { PublicClientApplication } from '@azure/msal-browser';

import { msalConfig } from './loginConfig';

export const msalInstance = new PublicClientApplication(msalConfig);
